const mobileMenuClasses = 'h-[calc(100vh_-_5rem)] overflow-y-auto overscroll-contain';

const mobileHeaderCommonTheme = {
  mobileMenuClasses,
};

export default mobileHeaderCommonTheme;
